import { Skeleton } from 'antd';

const SavedComparisonSkeleton = () => {
  return (
    <div style={{ maxHeight: 'calc(100vh - 200px)', overflow: 'hidden' }}>
      <Skeleton />
      <br />
      <Skeleton />
      <br />
      <Skeleton />
      <br />
      <Skeleton />
      <br />
      <Skeleton />
      <br />
      <Skeleton />
      <br />
      <Skeleton />
      <br />
      <Skeleton />
    </div>
  );
};

export default SavedComparisonSkeleton;
